/* global HacoTellusPDF:false */

class SaveAsPdf {
	constructor( ) {
		this.btn = null;
	}

	init( ) {
		if ( ! window.HacoTellusPDF || ! window.fetch ) {
			return;
		}

		this.btn = document.querySelector( '.save-as-pdf-btn' );
		if ( ! this.btn ) {
			return;
		}

		this.onClick = this.onClick.bind( this );
		this.btn.addEventListener( 'click', this.onClick );
	}

	async onClick( e ) {
		e.preventDefault();

		if ( ! window.HacoTellusPDF?.endpoint || ! window.HacoTellusPDF?.nonce || ! window.HacoTellusPDF?.productId ) {
			// eslint-disable-next-line no-console
			console.error( 'Missing PDF config.' );
			return;
		}

		const originalText = this.btn.textContent;
		this.btn.setAttribute( 'aria-busy', 'true' );
		this.btn.disabled = true;
		this.btn.textContent = HacoTellusPDF.i18n.generating;

		try {
			const res = await fetch( window.HacoTellusPDF.endpoint, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-WP-Nonce': window.HacoTellusPDF.nonce,
				},
				body: JSON.stringify( { product_id: window.HacoTellusPDF.productId } ),
			} );

			// Helpful diagnostics:
			// eslint-disable-next-line no-console
			console.log( 'PDF status:', res.status, res.statusText );

			let data;
			const ct = ( res.headers.get( 'content-type' ) || '' ).toLowerCase();
			if ( ct.includes( 'application/json' ) ) {
				data = await res.json();
			} else {
				const text = await res.text();
				// eslint-disable-next-line no-console
				console.error( 'Non-JSON response body:', text );
				throw new Error( 'Server did not return JSON' );
			}

			if ( ! res.ok || ! data?.url ) {
				// eslint-disable-next-line no-console
				console.error( 'PDF error payload:', data );
				this.btn.textContent = HacoTellusPDF.i18n.failed;
				return;
			}

			// Trigger download/navigation to the generated file.
			window.open( data.url, '_blank', 'noopener,noreferrer' ); // open in new tab
			// window.location.href = data.url; // open in current window
			this.btn.textContent = HacoTellusPDF.i18n.opening;
		} catch ( err ) {
			// eslint-disable-next-line no-console
			console.error( 'PDF error:', err );
			this.btn.textContent = HacoTellusPDF.i18n.failed;
		} finally {
			setTimeout( ( ) => {
				this.btn.disabled = false;
				this.btn.removeAttribute( 'aria-busy' );
				this.btn.textContent = originalText;
			}, 1500 );
		}
	}
}

const saveAsPdf = new SaveAsPdf( );
document.addEventListener( 'DOMContentLoaded', ( ) => saveAsPdf.init( ) );
